import { render, staticRenderFns } from "./SliderItem.vue?vue&type=template&id=68ce8232&scoped=true&"
import script from "./SliderItem.vue?vue&type=script&lang=js&"
export * from "./SliderItem.vue?vue&type=script&lang=js&"
import style0 from "./SliderItem.vue?vue&type=style&index=0&id=68ce8232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce8232",
  null
  
)

export default component.exports